import { render, staticRenderFns } from "./HowToSigfoxNew.vue?vue&type=template&id=7121c274&"
import script from "./HowToSigfoxNew.vue?vue&type=script&lang=js&"
export * from "./HowToSigfoxNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports